import { APIHelper } from '@/services/axios';

const getRegions = (service_id, vehicle_model_id) =>
  APIHelper.get(
    `/regions?service_id=${service_id}&vehicle_model_id=${vehicle_model_id}`,
  );

const getCommunes = (region_id, service_id, vehicle_model_id) =>
  APIHelper.get(
    `/regions/${region_id}/communes?service_id=${service_id}&vehicle_model_id=${vehicle_model_id}`,
  );

const getOffices = (commune_id, service_id, vehicle_model_id) =>
  APIHelper.get(
    `/branches?commune_id=${commune_id}&service_id=${service_id}&vehicle_model_id=${vehicle_model_id}`,
  );

export { getRegions, getCommunes, getOffices };
